// extracted by mini-css-extract-plugin
export default {"faqSection":"FaqSection_faqSection__iIxbv","question":"FaqSection_question__D1m8Q","answer":"FaqSection_answer__0A18I","line":"FaqSection_line__IJ4kT"};